<script lang="ts">
  import type { CohortRow } from '../admin';
  import CohortHeatmap from './CohortHeatmap.svelte';

  // First-contribution cohort retention grid + its standard caption, wrapped as one
  // section so the overview, contributors and engagement pages share a single source
  // of the chart and its explanation (no duplicated copy across routes).
  let { cohorts, class: cls = '' }: { cohorts: CohortRow[]; class?: string } = $props();
</script>

<section class="rounded-box border hair bg-base-100 p-5 {cls}">
  <div class="eyebrow mb-1">First-contribution cohorts</div>
  <p class="mb-3 text-xs text-base-content/65">
    <strong class="font-medium text-base-content/75">Day 0</strong> is the intake — how many members first
    contributed that month. Each later column is how many are still contributing N days on: the cell shows
    the count, its colour the share retained, counting only those old enough to have reached N (recent
    members aren't scored as churned). Hover for the percentage and roles; click a cell to open those
    members. (First contribution, not join date — lurkers aren't visible.)
  </p>
  {#if cohorts.length === 0}
    <p class="text-sm text-base-content/62">No cohorts old enough to measure yet.</p>
  {:else}
    <CohortHeatmap {cohorts} />
  {/if}
</section>
